<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-shipping-container"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Code">
        <FormInputText placeholder="Code" v-model="stockContainer.code" field="code" />
      </FormRow>
      <FormRow label="Name">
        <FormInputText placeholder="Name" v-model="stockContainer.name" field="name" />
      </FormRow>
      <FormRow label="Block Quantity">
        <FormInputText placeholder="Block Quantity" v-model="stockContainer.blockQuantity" field="blockQuantity" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "StockContainerDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      stockContainerId: null,
      stockContainer: {},
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Stock Container' : 'Edit Stock Container'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(stockContainer) {
      // Reset form
      this.stockContainer = { }
      this.stockContainerId = 0
      this.dialogForm = {}
      this.submitting = false

      if(stockContainer != null) {
        this.stockContainer = _.cloneDeep(stockContainer)
        this.stockContainerId = stockContainer.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var stockContainerData = _.cloneDeep(this.$data.stockContainer)

      if(this.isCreateMode) {
        this.$apiService.inventoryService.createStockContainer(stockContainerData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.inventoryService.updateStockContainer(this.stockContainerId, stockContainerData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>